import React from 'react';
import styled from 'styled-components';

import Picture from '../../../../containers/assets/instructor-onboarding-image5.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  flex: 1;
`;

const Container = styled.div`
  padding: 40px;
  width: 80%;
  max-width: 794px;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  b {
    color: #ed716d;
  }

  ul {
    list-style-type: disc;
    margin-left: 15px;
    margin-top: 5px;

    li {
      font-family: 'Mukta Vaani';
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      color: rgba(0, 27, 59, 0.6);
    }
  }
`;

const Image = styled.div`
  display: flex;
  margin-top: 12px;
`;

const WelcomeStep3 = () => (
  <Wrapper>
    <Container>
      <Text1>Welcome</Text1>
      <Text2>Making Your Life A Little Easier</Text2>
      <Text3>
        While your students work on this group project,<br />
        <ul>
          <li>You will receive insights on their decision making and teamwork skills,</li>
          <li>You will be able to track if they are doing the work, and</li>
          <li>
            You will not have to calculate any grades (i.e. grading is automated) and
            grading results can be easily uploaded to your LMS in just one click.
          </li>
        </ul>
      </Text3>

      <Image>
        <img src={Picture} alt="" />
      </Image>
    </Container>
  </Wrapper>
);

export default WelcomeStep3;



// WEBPACK FOOTER //
// ./src/instructor/components/onboarding/welcome/step3.js